<template>
  <div
    class="yxtbiz-signup-config relative"
    :style="{ height }"
    v-loading="loadingValue"
  >
    <div class="fs14 h56 lh56 fw500 pl26 b3b1 border-box" v-show="cfgs.title">
      {{ language()[cfgs.title] }}
    </div>
    <div :class="`absolute left0 right0 ${cfgs.title?'top56 pt24':'top0'} pt24 bottom56  o-auto`">
      <yxt-form
        ref="form"
        label-position="right"
        label-width="134px"
        :model="data"
        :rules="rules"
        :validate-on-rule-change="false"
      >
        <template v-for="(form, fIndex) in cfgs.forms">
          <div :class="'relative fs16 fw500 mb24 ml40 sign'+(fIndex!==0?' mt30':'') " :key="fIndex" v-show="form.title">
            {{ language()[form.title] }}
          </div>
          <template v-for="(control, cIndex) in form.controls">
            <template v-if="isShow(control.show) && !isHide(control.hide)">
              <yxt-form-item
                :label-tooltip="language()[control.tooltip]"
                :class="control.form ? ((control.key==='wheres' && data['wheres'].length>0)||(control.key==='allows'&&data.allowOtherEnroll===1) ||control.key==='needAudit' ||(control.key==='needAttach'&&data.needAttach===1)?'mb0':'mb18') : ''"
                :key="fIndex + '' + cIndex"
                :label="language()[control.label]"
                :prop="control.key"
              >
                <controls
                  :data="data"
                  :control="control"
                  :cfgs="cfgs"
                  @validateField="validateField"
                ></controls>
              </yxt-form-item>
            </template>
            <template v-if="control.form">
              <template v-for="(ctl, i) in control.form">
                <template v-if="ctl.key==='requireCount' && data['wheres'].length>0">
                  <yxt-form-item
                    :label-tooltip="language()[ctl.tooltip]"
                    class="mb8"
                    :key="fIndex + '' + cIndex + '' + i"
                    :label="language()[ctl.label]"
                    :label-width="
                      ((ctl.label && ctl.label !== ' ') || ctl.labelShow)
                        ? ctl.labelWidth || '210px'
                        : ''
                    "
                    :prop="ctl.key"
                  >
                    <controls
                      :disabled="data['wheres'].length===1"
                      :data="data"
                      :control="ctl"
                      :cfgs="cfgs"
                      @validateField="validateField"
                    ></controls>
                  </yxt-form-item>
                </template>
                <template v-if="ctl.key!=='requireCount'&& isShow(ctl.show) && !isHide(ctl.hide)">
                  <yxt-form-item
                    :label-tooltip="language()[ctl.tooltip]"
                    :class="ctl.key ==='concer' ||ctl.key==='conexams'?'mb18 condition':'mb18'"
                    :key="fIndex + '' + cIndex + '' + i"
                    :label="language()[ctl.label]"
                    :label-width="
                      ((ctl.label && ctl.label !== ' ') || ctl.labelShow)
                        ? ctl.labelWidth || '210px'
                        : ''
                    "
                    :prop="ctl.key"
                  >
                    <controls
                      :data="data"
                      :control="ctl"
                      :cfgs="cfgs"
                      @validateField="validateField"
                    ></controls>
                  </yxt-form-item>
                </template>
              </template>
            </template>
          </template>
        </template>
      </yxt-form>
    </div>
    <div
    v-if="!isHideBtn"
      class="
        absolute
        left0
        right0
        h56
        lh56
        bottom0
        box-shadow-opts
        align-center
      "
    >
      <yxt-button @click.stop="cancel">{{ language().btn_cancel }}</yxt-button>
      <yxt-button type="primary" @click.stop="save" :loading="loadingSave">{{
        language().btn_save
      }}</yxt-button>
    </div>
    <yxt-drawer
      :title="language()[cfgs.drawer.title]"
      :header-border="!!cfgs.drawer.title"
      :destroy-on-close="true"
      :visible.sync="cfgs.drawer.show"
      :size="cfgs.drawer.size"
      :before-close="closeDrawer"
    >
      <template v-if="cfgs.drawer.name">
        <template v-if="cfgs.drawer.key === 'projId'">
          <component
            :projId="cfgs.drawer.value"
            :key="cfgs.drawer.name"
            :is="cfgs.drawer.name"
            v-bind="{
              ...cfgs.drawer.props,
              tmplCode: this.data.auditTemplateCode,
              dataPermissionCode:auditDataPermissionCode ?auditDataPermissionCode:cfgs.drawer.props.dataPermissionCode,
              functionCode:functionCode ?functionCode:cfgs.drawer.props.functionCode
            }"
            @success="auditSuccess"
          />
        </template>
        <template v-else-if="cfgs.drawer.key === 'personRange'">
          <component
            :personRange.sync="cfgs.drawer.value"
            :key="cfgs.drawer.name"
            :is="cfgs.drawer.name"
            v-bind="{ ...cfgs.drawer.props,enableGroupCorp,visibleOrgSelector,targetOrgId,visibleOrgIds,disabledOrgSelect,dataPermissionCode:dataPermissionCode && cfgs.drawer.props.hasOwnProperty('dataPermissionCode')?dataPermissionCode:cfgs.drawer.props.dataPermissionCode,functionCode:functionCode && cfgs.drawer.props.hasOwnProperty('functionCode')?functionCode:cfgs.drawer.props.functionCode}"
          />
        </template>
        <template v-else-if="cfgs.drawer.key === 'surveies'">
          <component
            :selected="
              cfgs.drawer.value && cfgs.drawer.value.length
                ? cfgs.drawer.value[0].id
                : undefined
            "
            :key="cfgs.drawer.name"
            :is="cfgs.drawer.name"
            v-bind="{ ...cfgs.drawer.props }"
            @select="formSelect"
          />
        </template>
        <template v-else>
          <component
            v-model="cfgs.drawer.value"
            :key="cfgs.drawer.name"
            :is="cfgs.drawer.name"
            v-bind="{ ...cfgs.drawer.props,groupSelect: enableGroupCorp,groupShared,orgFunctionCode,orgDataPermissionCode,dataPermissionCode:dataPermissionCode && cfgs.drawer.props.hasOwnProperty('dataPermissionCode')?dataPermissionCode:cfgs.drawer.props.dataPermissionCode,
            functionCode:functionCode && cfgs.drawer.props.hasOwnProperty('functionCode')?functionCode:cfgs.drawer.props.functionCode}"
          />
        </template> 
      </template>
      <div slot="footer" v-if="cfgs.drawer.footer">
        <yxt-button plain @click="closeDrawer">{{
          language().btn_cancel
        }}</yxt-button>
        <yxt-button
          type="primary"
          @click="confirmDrawer"
          v-if="!cfgs.drawer.confirmButton"
          >{{ language().btn_confirm }}</yxt-button
        >
      </div>
      <div slot="footer" v-else></div>
    </yxt-drawer>
  </div>
</template>
<script>
import controls from './controls.vue';

export default {
  name: 'YxtbizSignupConfig',
  inject: ['language'],
  components: {
    controls
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    enableMsg: {
      type: Boolean,
      default: true
    },
    height: {
      type: String,
      default: '600px'
    },
    // 是否展示集团化选择器
    enableGroupCorp: {
      type: Boolean,
      default: false
    },
    // 集团版是否展示机构选择组件
    visibleOrgSelector: {
      type: Boolean,
      default: false
    },
    // 集团版指定机构Id
    targetOrgId: {
      type: String,
      default: ''
    },
    // 集团版选人组件各平台是否独立选择
    visibleOrgIds: {
      type: Array,
      default: ()=>{return [];}
    },
    // 集团版机构选择组件是否禁用
    disabledOrgSelect: {
      type: Boolean,
      default: false
    },
    // 证书专用：是否包含集团的共享资源。
    groupShared: {
      type: Boolean,
      default: false
    },
    // 考试-集团机构权限页面的导航编号
    orgFunctionCode: {
      type: String,
      default: ''
    },
    // 考试-集团机构权限数据权限点
    orgDataPermissionCode: {
      type: String,
      default: ''
    },
    // 该报名是否是集团版的报名
    grpMode: {
      type: Number,
      default: 0
    },
    // 选人组件的
    dataPermissionCode: {
      type: String,
      default: ''
    },
    // 审核的
    auditDataPermissionCode: {
      type: String,
      default: ''
    },
    functionCode: {
      type: String,
      default: ''
    },
    /**
     * appCode       : 接入应用的标识appCode
     * projectName   : 报名项目名称
     * coverUrl      ：报名封面URL （非必填）
     * shortUrl      ：短链接
     * intro         ：简介信息
     * clientInfo    ：扩展字段 json格式 (非必填)
     * chargeUsers   ：项目负责人 （[{id : "用户id" , name : "用户名称" }]）
     * appProjectId  ：接入的应用项目id（业务id）
     * appProjectUrl ：接入的应用项目的访问url （跳详情用到）
     * remarkUrl     ：简介oss地址（非必填）
     * grpMode       ：是否集团版 0 否 1是（不填为0）
     * createUserId  ：创建人
     * createOrgId   ：创建人机构
     * projectId     : 报名组件id，第一次创建 需要 传一个虚拟的报名id
     */
    createParams: {
      type: Object,
      default: ()=>{
        return {};
      }
    },
    isHideBtn: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loadingValue: false,
      loadingSave: false,
      auditTemplateCode: 0,
      data: {
        id: '',
        formalQuota: 0,
        maxQuota: 0,
        pointPrice: 0,
        enrollTime: [],
        enrollRange: [],
        needExcludeRange: 0,
        excludeRange: [],
        allows: [],
        allowSelfEnroll: 1,
        allowOtherEnroll: 0,
        otherEnrollType: 3,
        appointEnrollUserIds: [],
        needAudit: 0,
        auditTemplateCode: '',
        positions: [],
        grades: [],
        cers: [],
        exams: [],
        wheres: [],
        score: 0,
        scoreType: 2,
        entryDate: '',
        entryDateType: 4,
        needSurvey: 0,
        surveies: [],
        needAttach: 0,
        attachTypeOption: [],
        allowGiveUp: 0,
        giveUpDeadline: '',
        allowMultipleEnroll: 0,
        maxEnrollCount: 0,
        multipleEnrollType: [],
        teacherLevel: [],
        projectEnrollRangeCache: {
          rangeList: [],
          rangeExcludeList: []
        },
        requireCount: 0,
        concer: 1,
        conexams: 1
      },
      cfgs: {
        title: 'tit_settings',
        forms: [
          // {
          //   title: 'lbl_apply_msg',
          //   controls: [{
          //     class: 'w128',
          //     label: 'lbl_official_quota',
          //     name: 'yxt-input-number',
          //     key: 'formalQuota',
          //     max: 999999999,
          //     min: 0,
          //     infoNum: '0-999999999，0',
          //     info: 'msg_noRestriction',
          //     validators: [{
          //       required: true,
          //       message: 'msg_officialquotanotnull',
          //       trigger: 'blur'
          //     },
          //     {
          //       funcName: 'compare',
          //       compare: [{
          //         value: '!==',
          //         left: 'formalQuota',
          //         right: 0
          //       },
          //       {
          //         value: '!==',
          //         left: 'maxQuota',
          //         right: 0
          //       },
          //       {
          //         value: '>',
          //         left: 'formalQuota',
          //         right: 'maxQuota'
          //       }],
          //       message: 'msg_quota_greater',
          //       trigger: 'change'
          //     }]
          //   },
          //   {
          //     class: 'w128',
          //     label: 'lbl_allownum',
          //     name: 'yxt-input-number',
          //     key: 'maxQuota',
          //     max: 999999999,
          //     min: 0,
          //     infoNum: '0-999999999，0',
          //     info: 'msg_noRestriction',
          //     validators: [{
          //       required: true,
          //       message: 'msg_numallowednotnull',
          //       trigger: 'blur'
          //     },
          //     {
          //       funcName: 'compare',
          //       compare: [{
          //         value: '!==',
          //         left: 'formalQuota',
          //         right: 0
          //       },
          //       {
          //         value: '!==',
          //         left: 'maxQuota',
          //         right: 0
          //       },
          //       {
          //         value: '>',
          //         left: 'formalQuota',
          //         right: 'maxQuota'
          //       }],
          //       message: 'msg_quota_less',
          //       trigger: 'change'
          //     }]
          //   },
          //   {
          //     class: 'w128',
          //     label: 'lbl_integral_of_consumption',
          //     name: 'yxt-input-number',
          //     key: 'pointPrice',
          //     max: 99999,
          //     min: 0,
          //     info: 'tip_zero_for_free'
          //   },
          //   {
          //     class: 'w403',
          //     label: 'lbl_registration_time',
          //     name: 'yxt-date-picker',
          //     type: 'datetimerange',
          //     key: 'enrollTime',
          //     format: 'yyyy-MM-dd HH:mm'
          //   },
          //   {
          //     class: 'w708',
          //     label: 'lbl_enroll_range',
          //     name: 'settings-checked',
          //     key: 'enrollRange',
          //     placeholder: 'lbl_errollrange_placeholder',
          //     drawer: {
          //       name: 'yxtbiz-check-person-range',
          //       size: '960px',
          //       key: 'personRange',
          //       footer: true,
          //       type: 'array',
          //       props: {
          //         class: 'pb24',
          //         tabs: ['department', 'usergroup', 'person', 'import'],
          //         functionCode: 'te_authentication',
          //         dataPermissionCode: 'lecturer_signup_extent',
          //         options: {
          //           department: {
          //             childrenIncluded: true
          //           }
          //         }
          //       }
          //     },
          //     validators: [{
          //       type: 'array',
          //       required: true,
          //       message: 'msg_range_is_not_empty',
          //       trigger: 'change'
          //     }],
          //     form: [{
          //       name: 'yxt-checkbox',
          //       key: 'needExcludeRange',
          //       checkboxLabel: 'lbl_addexclusions',
          //       trueLabel: 1,
          //       falseLabel: 0
          //     },
          //     {
          //       show: {
          //         needExcludeRange: 1
          //       },
          //       class: 'w631',
          //       label: 'lbl_exclude_user',
          //       name: 'settings-checked',
          //       key: 'excludeRange',
          //       placeholder: 'lbl_exclude_user_placeholder',
          //       drawer: {
          //         name: 'yxtbiz-check-person-range',
          //         size: '960px',
          //         key: 'personRange',
          //         footer: true,
          //         type: 'array',
          //         props: {
          //           class: 'pb24',
          //           tabs: ['department', 'usergroup', 'person', 'import'],
          //           functionCode: 'te_authentication',
          //           dataPermissionCode: 'lecturer_signup_extent',
          //           options: {
          //             department: {
          //               childrenIncluded: true
          //             }
          //           }
          //         }
          //       },
          //       validators: [{
          //         type: 'array',
          //         required: true,
          //         message: 'msg_exclusion_can_not_be_null',
          //         trigger: 'change'
          //       }]
          //     }]
          //   },
          //   {
          //     class: 'inline-block',
          //     label: 'lbl_set_mode',
          //     name: 'yxt-checkbox-group',
          //     key: 'allows',
          //     options: [{
          //       key: 'allowSelfEnroll',
          //       checkboxLabel: 'lbl_self_registration'
          //     },
          //     {
          //       key: 'allowOtherEnroll',
          //       checkboxLabel: 'lbl_all'
          //     }],
          //     info: 'tip_replaceEnroll',
          //     tooltip: 'tip_replaceEnroll',
          //     validators: [{
          //       type: 'array',
          //       required: true,
          //       message: 'msg_set_mode',
          //       trigger: 'change'
          //     }],
          //     form: [{
          //       show: {
          //         allowOtherEnroll: 1
          //       },
          //       name: 'yxt-radio-group',
          //       key: 'otherEnrollType',
          //       direction: 'row',
          //       options: [{
          //         label: 'lbl_check_type1',
          //         value: 1
          //       },
          //       {
          //         label: 'lbl_check_type2',
          //         value: 2
          //       },
          //       {
          //         label: 'lbl_check_type3',
          //         value: 3
          //       }]
          //     },
          //     {
          //       show: {
          //         allowOtherEnroll: 1,
          //         otherEnrollType: 3
          //       },
          //       label: ' ',
          //       class: 'w708',
          //       name: 'settings-checked',
          //       key: 'appointEnrollUserIds',
          //       placeholder: 'lbl_check_type_placeholder',
          //       drawer: {
          //         name: 'yxtbiz-check-person-range',
          //         size: '960px',
          //         key: 'personRange',
          //         footer: true,
          //         type: 'array',
          //         props: {
          //           class: 'pb24',
          //           tabs: ['department', 'usergroup', 'person', 'import'],
          //           functionCode: 'te_authentication',
          //           dataPermissionCode: 'te_setAgent_exetent',
          //           options: {
          //             department: {
          //               childrenIncluded: true
          //             }
          //           }
          //         }
          //       },
          //       validators: [{
          //         type: 'array',
          //         required: true,
          //         message: 'msg_replaceUsersnotnull',
          //         trigger: 'change'
          //       }]
          //     }]
          //   },
          //   {
          //     label: 'lbl_auditset',
          //     name: 'yxt-checkbox',
          //     key: 'needAudit',
          //     trueLabel: 1,
          //     falseLabel: 0,
          //     checkboxLabel: 'lbl_openaudit',
          //     form: [{
          //       show: {
          //         needAudit: 1
          //       },
          //       buttonLabel: 'btn_auditset',
          //       name: 'yxt-button',
          //       type: 'primary',
          //       key: 'id',
          //       drawer: {
          //         name: 'yxtbiz-audit-template',
          //         size: '960px',
          //         key: 'projId',
          //         type: 'string',
          //         props: {
          //           functionCode: 'te_authentication',
          //           dataPermissionCode: 'lecturer_enroll_extent'
          //         }
          //       }
          //     }]
          //   }]
          // },
          // {
          //   title: 'lbl_more_setting',
          //   controls: [{
          //     label: 'lbl_where',
          //     name: 'yxt-checkbox-group',
          //     key: 'wheres',
          //     options: [{
          //       value: 'positions',
          //       checkboxLabel: 'lbl_positions'
          //     },
          //     {
          //       value: 'grades',
          //       checkboxLabel: 'lbl_grades'
          //     },
          //     {
          //       value: 'cers',
          //       checkboxLabel: 'lbl_cers'
          //     },
          //     {
          //       value: 'exams',
          //       checkboxLabel: 'lbl_exams'
          //     },
          //     {
          //       value: 'score',
          //       checkboxLabel: 'lbl_score'
          //     },
          //     {
          //       value: 'entryDate',
          //       checkboxLabel: 'lbl_entryDate'
          //     },
          //     {
          //       value: 'teacherLevel',
          //       checkboxLabel: 'lbl_teacherLevel'
          //     }],
          //     form: [{
          //       show: {
          //         wheres: 'positions'
          //       },
          //       class: 'w631',
          //       label: 'lbl_job',
          //       name: 'settings-checked',
          //       key: 'positions',
          //       placeholder: 'msg_selectjob',
          //       drawer: {
          //         title: 'tit_selectjob',
          //         name: 'yxtbiz-check-person-range',
          //         size: '960px',
          //         key: 'personRange',
          //         footer: true,
          //         type: 'array',
          //         max: 10,
          //         props: {
          //           tabs: ['position'],
          //           functionCode: 'te_authentication',
          //           dataPermissionCode: 'lecturer_signup_extent'
          //         }
          //       },
          //       validators: [{
          //         type: 'array',
          //         required: true,
          //         message: 'msg_job',
          //         trigger: 'change'
          //       }]
          //     },
          //     {
          //       show: {
          //         wheres: 'grades'
          //       },
          //       class: 'w631',
          //       label: 'lbl_grades',
          //       name: 'settings-checked',
          //       key: 'grades',
          //       placeholder: 'msg_selectpositionlevel',
          //       drawer: {
          //         title: 'tit_selectpositionlevel',
          //         name: 'yxtbiz-check-person-range',
          //         size: '960px',
          //         key: 'personRange',
          //         footer: true,
          //         type: 'array',
          //         max: 10,
          //         props: {
          //           tabs: ['level'],
          //           functionCode: 'te_authentication',
          //           dataPermissionCode: 'lecturer_signup_extent'
          //         }
          //       },
          //       validators: [{
          //         type: 'array',
          //         required: true,
          //         message: 'msg_grades',
          //         trigger: 'change'
          //       }]
          //     },
          //     {
          //       show: {
          //         wheres: 'cers'
          //       },
          //       class: 'w631',
          //       label: 'lbl_cers',
          //       name: 'settings-checked',
          //       key: 'cers',
          //       placeholder: 'msg_selectcer',
          //       drawer: {
          //         title: 'tit_selectcer',
          //         name: 'yxtbiz-certificate-selector',
          //         size: '960px',
          //         footer: true,
          //         type: 'array',
          //         max: 10,
          //         props: {
          //           class: 'pb24',
          //           functionCode: 'te_authentication'
          //         }
          //       },
          //       validators: [{
          //         type: 'array',
          //         required: true,
          //         message: 'msg_cers',
          //         trigger: 'change'
          //       }]
          //     },
          //     {
          //       show: {
          //         wheres: 'exams'
          //       },
          //       class: 'w631',
          //       label: 'lbl_exams',
          //       name: 'settings-checked',
          //       key: 'exams',
          //       placeholder: 'msg_selectexam',
          //       drawer: {
          //         title: 'tit_selectexam',
          //         name: 'yxtbiz-exam-arrange-selector',
          //         size: '960px',
          //         footer: true,
          //         type: 'array',
          //         max: 10,
          //         props: {
          //           class: 'pb24',
          //           functionCode: 'te_authentication'
          //         }
          //       },
          //       validators: [{
          //         type: 'array',
          //         required: true,
          //         message: 'msg_exams',
          //         trigger: 'change'
          //       }]
          //     },
          //     {
          //       show: {
          //         wheres: 'score'
          //       },
          //       rowClass: 'w660',
          //       class: 'w296_5 inline-block',
          //       label: 'lbl_score',
          //       name: 'yxt-input-number',
          //       key: 'score',
          //       max: 999999,
          //       min: 0,
          //       validators: [{
          //         required: true,
          //         message: 'msg_score',
          //         trigger: 'blur'
          //       }],
          //       msgClass: 'w40 inline-block align-center',
          //       msgKey: 'lbl_and',
          //       msgCtl: {
          //         name: 'yxt-select',
          //         class: 'w296_5 inline-block',
          //         key: 'scoreType',
          //         options: [{
          //           value: 4,
          //           label: 'lbl_before'
          //         },
          //         {
          //           value: 2,
          //           label: 'lbl_future'
          //         }]
          //       }
          //     },
          //     {
          //       show: {
          //         wheres: 'entryDate'
          //       },
          //       rowClass: 'w660',
          //       class: 'w296_5 inline-block',
          //       label: 'lbl_entryDate',
          //       name: 'yxt-date-picker',
          //       type: 'date',
          //       key: 'entryDate',
          //       format: 'yyyy-MM-dd',
          //       validators: [{
          //         required: true,
          //         message: 'msg_entryDate',
          //         trigger: 'change'
          //       }],
          //       msgClass: 'w40 inline-block align-center',
          //       msgKey: 'lbl_and',
          //       msgCtl: {
          //         name: 'yxt-select',
          //         class: 'w296_5 inline-block',
          //         key: 'entryDateType',
          //         options: [{
          //           value: 4,
          //           label: 'lbl_before'
          //         },
          //         {
          //           value: 2,
          //           label: 'lbl_future'
          //         }]
          //       }
          //     },
          //     {
          //       show: {
          //         wheres: 'teacherLevel'
          //       },
          //       class: 'w631',
          //       setwidth: 631,
          //       label: 'lbl_teacherLevel',
          //       name: 'yxtbiz-teacher-level',
          //       key: 'teacherLevel',
          //       multipleLimit: true,
          //       validators: [{
          //         type: 'array',
          //         required: true,
          //         message: 'msg_teacherLevel',
          //         trigger: 'blur'
          //       }]
          //     }]
          //   },
          //   {
          //     hide: {
          //       allowOtherEnroll: 1
          //     },
          //     label: 'lbl_enrollform',
          //     name: 'yxt-checkbox',
          //     key: 'needSurvey',
          //     trueLabel: 1,
          //     falseLabel: 0,
          //     checkboxLabel: 'msg_submitform',
          //     tooltip: 'tip_submitform',
          //     form: [{
          //       show: {
          //         needSurvey: 1
          //       },
          //       label: ' ',
          //       name: 'settings-checked',
          //       key: 'surveies',
          //       placeholder: 'lbl_enrollformnotnull',
          //       drawer: {
          //         title: 'tit_selectenroll',
          //         name: 'yxtbiz-survey-template',
          //         size: '960px',
          //         key: 'surveies',
          //         footer: true,
          //         confirmButton: 'hide',
          //         type: 'array',
          //         props: {
          //           class: 'pb24',
          //           type: 0,
          //           functionCode: 'te_authentication'
          //         }
          //       },
          //       validators: [{
          //         type: 'array',
          //         required: true,
          //         message: 'msg_exclusion_can_not_be_null',
          //         trigger: 'change'
          //       }]
          //     }]
          //   },
          //   {
          //     label: 'lbl_information',
          //     name: 'yxt-checkbox',
          //     key: 'needAttach',
          //     trueLabel: 1,
          //     falseLabel: 0,
          //     checkboxLabel: 'msg_information',
          //     form: [{
          //       show: {
          //         needAttach: 1
          //       },
          //       label: 'lbl_attachment_type',
          //       name: 'yxt-checkbox-group',
          //       key: 'attachTypeOption',
          //       options: [{
          //         value: 1,
          //         checkboxLabel: 'lbl_file'
          //       },
          //       {
          //         value: 2,
          //         checkboxLabel: 'lbl_picture'
          //       },
          //       {
          //         value: 3,
          //         checkboxLabel: 'lbl_video'
          //       }],
          //       validators: [{
          //         type: 'array',
          //         required: true,
          //         message: 'msg_attachment_type',
          //         trigger: 'change'
          //       }]
          //     }]
          //   },
          //   {
          //     label: 'lbl_give_up',
          //     name: 'yxt-checkbox',
          //     key: 'allowGiveUp',
          //     trueLabel: 1,
          //     falseLabel: 0,
          //     checkboxLabel: 'lbl_done_disqualification',
          //     form: [{
          //       show: {
          //         allowGiveUp: 1
          //       },
          //       class: 'w200',
          //       label: 'lbl_endtime',
          //       name: 'yxt-date-picker',
          //       key: 'giveUpDeadline',
          //       type: 'date',
          //       placeholder: 'lbl_abandontime',
          //       format: 'yyyy-MM-dd',
          //       info: 'msg_intimeallowgiveup',
          //       validators: [{
          //         required: true,
          //         message: 'msg_endtime',
          //         trigger: 'change'
          //       }]
          //     }]
          //   },
          //   {
          //     label: 'lbl_dc_count',
          //     name: 'yxt-checkbox',
          //     key: 'allowMultipleEnroll',
          //     trueLabel: 1,
          //     falseLabel: 0,
          //     checkboxLabel: 'msg_dc_count',
          //     form: [{
          //       show: {
          //         allowMultipleEnroll: 1
          //       },
          //       class: 'w200',
          //       labelWidth: '254px',
          //       label: 'lbl_max_count',
          //       name: 'yxt-input-number',
          //       key: 'maxEnrollCount',
          //       min: 0,
          //       max: 99,
          //       info: 'msg_max_count',
          //       validators: [{
          //         required: true,
          //         message: 'msg_max_vcount',
          //         trigger: 'change'
          //       }]
          //     },
          //     {
          //       show: {
          //         allowMultipleEnroll: 1
          //       },
          //       labelWidth: '182px',
          //       label: 'lbl_reason',
          //       name: 'yxt-checkbox-group',
          //       key: 'multipleEnrollType',
          //       options: [{
          //         value: 2,
          //         checkboxLabel: 'lbl_failed'
          //       },
          //       {
          //         value: 3,
          //         checkboxLabel: 'lbl_give_up'
          //       },
          //       {
          //         value: 4,
          //         checkboxLabel: 'lbl_disqualification'
          //       }],
          //       validators: [{
          //         type: 'array',
          //         required: true,
          //         message: 'msg_reason',
          //         trigger: 'change'
          //       }]
          //     }]
          //   }]
          // }
        ],
        drawer: {
          title: '',
          show: false,
          value: [],
          key: '',
          type: ''
        }
      },
      num: 0,
      numTimer: null
    };
  },
  computed: {
    // 校验
    rules() {
      const rules = {};
      const languages = this.language();
      const cfgs = JSON.parse(JSON.stringify(this.cfgs || {}));
      for (let i = 0; i < cfgs.forms.length; i++) {
        for (let j = 0; j < cfgs.forms[i].controls.length; j++) {
          const control = cfgs.forms[i].controls[j];
          if (control.validators && control.validators.length) {
            const validators = [...control.validators];
            for (let z = 0; z < validators.length; z++) {
              if (
                validators[z].message &&
                /^(msg|lbl|tit|btn|tip)_/.test(validators[z].message)
              ) {
                validators[z].message = languages[validators[z].message];
              }
              if (validators[z].funcName && this[validators[z].funcName]) {
                validators[z].validator = this[validators[z].funcName](
                  validators[z][validators[z].funcName],
                  validators[z].message
                );
              }
            }
            if (this.isShow(control.show) && !this.isHide(control.hide)) {
              rules[control.key] = validators;
            }
          }
          if (control.form) {
            for (let k = 0; k < control.form.length; k++) {
              const ctl = control.form[k];
              if (ctl.validators && ctl.validators.length) {
                const validators = [...ctl.validators];
                for (let z = 0; z < validators.length; z++) {
                  if (
                    validators[z].message &&
                    /^(msg|lbl|tit|btn|tip)_/.test(validators[z].message)
                  ) {
                    validators[z].message = languages[validators[z].message];
                  }
                  if (validators[z].funcName && this[validators[z].funcName]) {
                    validators[z].validator = this[validators[z].funcName](
                      validators[z][validators[z].funcName],
                      validators[z].message
                    );
                  }
                }
                if (this.isShow(ctl.show) && !this.isHide(ctl.hide)) {
                  rules[ctl.key] = validators;
                }
              }
            }
          }
        }
      }
      return rules;
    }
  },
  methods: {
    // 验证
    ...{
      // 比较
      compare(rules, message) {
        return (rule, value, callback) => {
          let result = true;
          for (let i = 0; i < rules.length; i++) {
            const left =
              this.data[rules[i].left] === undefined
                ? rules[i].left
                : this.data[rules[i].left];
            const right =
              this.data[rules[i].right] === undefined
                ? rules[i].right
                : this.data[rules[i].right];
            if (rules[i].value === '!==') {
              result = result ? left !== right : false;
            } else if (rules[i].value === '>') {
              result = result ? left > right : false;
            }
          }
          if (result) {
            callback(new Error(message));
          } else {
            callback();
          }
        };
      }
    },
    // 行为
    ...{
      variation() {
        const data = JSON.stringify(this.data);
        return data === this.dataCache;
      },
      validateField(key) {
        this.$refs.form.validateField(key);
      },
      closeDrawer() {
        this.validateField(this.cfgs.drawer.dataKey);
        this.$set(this.cfgs, 'drawer', {
          title: '',
          show: false,
          value: this.cfgs.drawer.type === 'array' ? [] : '',
          key: '',
          type: ''
        });
      },
      confirmDrawer() {
        const max = this.cfgs.drawer.max;
        const value = max
          ? this.cfgs.drawer.value.splice(0, max)
          : this.cfgs.drawer.value;
        this.data[this.cfgs.drawer.dataKey] =
          this.cfgs.drawer.type === 'array' ? [...value] : value;
        this.closeDrawer();
      },
      isHide(where) {
        if (where) {
          for (let key in where) {
            if (key === 'requireCount') {
              if (this.data['wheres'].length > 0) {
                return true;
              }
            } else {
              if (this.data[key].constructor === Array) {
                if (this.data[key].includes(where[key])) {
                  return true;
                }
              } else {
                if (this.data[key] === where[key]) {
                  return true;
                }
              }
            }
          }
        }
        return false;
      },
      isShow(where) {
        if (where) {
          for (let key in where) {
            if (key === 'requireCount') {
              if (this.data['wheres'].length === 0) {
                return false;
              } else {
                return true;
              }
            } else {
              if (this.data[key].constructor === Array) {
                if (!this.data[key].includes(where[key])) {
                  return false;
                }
              } else {
                if (this.data[key] !== where[key]) {
                  return false;
                }
              }
            }
          }
        }
        return true;
      },
      auditSuccess() {
        this.auditTemplateCode = 1;
        this.closeDrawer();
      },
      formSelect(value) {
        this.data[this.cfgs.drawer.key] = value
          ? [
            {
              id: value.id,
              name: value.name
            }
          ]
          : [];
        this.closeDrawer();
      },
      // 人员范围
      projectEnrollRange(enrollRange, excludeRange) {
        const projectEnrollRange = {
          rangeList: [],
          rangeExcludeList: []
        };
        for (const r of enrollRange || []) {
          projectEnrollRange.rangeList.push({
            objId: r.id,
            objName: r.name || r.fullname,
            objType: r._type,
            objLevel: r.includeAll
          });
        }
        for (const e of excludeRange || []) {
          projectEnrollRange.rangeExcludeList.push({
            objId: e.id,
            objName: e.name || e.fullname,
            objType: e._type
          });
        }
        return projectEnrollRange;
      },
      cancel() {
        this.$emit('cancel');
      },
      async editSignup() {
        const SDK = this.$parent.SDK;
        const rules = [];
        const wheres = this.data.wheres || [];
        for (let i = 0; i < wheres.length; i++) {
          let v = this.data[wheres[i]];
          if (this.data[wheres[i]] !== undefined) {
            if (this.data[wheres[i]].constructor === Array) {
              v = this.data[wheres[i]].map(_ => ({
                id: _.id || _.value,
                name: _.name || _.fullname || _.label
              }));
            }
          }
          let requireCount = null;
          if (wheres[i] === 'exams') {
            requireCount = this.data['conexams'];
          } else if (wheres[i] === 'cers') {
            requireCount = this.data['concer'];
          }
          rules.push({
            ruleCode: wheres[i],
            inputValue: {
              value: v,
              requireCount
            },
            compareType: this.data[wheres[i] + 'Type'] || 0,
            selected: 1
          });
        }
        const enrollTime = this.data.enrollTime || [];
        const projectEnrollRange = this.projectEnrollRange(
          this.data.enrollRange,
          this.data.excludeRange
        );
        const projectEnrollChangeFlag =
              JSON.stringify(projectEnrollRange) ===
              JSON.stringify(this.data.projectEnrollRangeCache)
                ? 0
                : 1;
        const data = {
          projectEnrollChangeFlag,
          startTime: enrollTime[0],
          endTime: enrollTime[1],
          pointPrice: this.data.pointPrice || 0,
          projectEnrollRange,
          needExcludeRange: this.data.needExcludeRange || 0,
          formalQuota: this.data.formalQuota || 0,
          maxQuota: this.data.maxQuota,
          allowInnerStaff: 1,
          allowVisitor: 0,
          visitorPwd: '',
          allowSelfEnroll: this.data.allowSelfEnroll || 0,
          allowOtherEnroll: this.data.allowOtherEnroll || 0,
          otherEnrollType: this.data.otherEnrollType || 0,
          appointEnrollUserIds: (this.data.appointEnrollUserIds || []).map(
            _ => ({
              id: _.id,
              name: _.name || _.fullname,
              type: _._type,
              level: _.includeAll
            })
          ),
          needAttach: this.data.needAttach || 0,
          attachTypeOption: this.data.attachTypeOption || [],
          needAudit: this.data.needAudit || 0,
          auditTemplateCode: this.data.auditTemplateCode,
          needSurvey: this.data.allowOtherEnroll
            ? 0
            : this.data.needSurvey || 0,
          surveyTemplateId:
                this.data.surveies && this.data.surveies.length
                  ? this.data.surveies[0].id
                  : '',
          surveyTemplateName:
                this.data.surveies && this.data.surveies.length
                  ? this.data.surveies[0].name
                  : '',
          allowGiveUp: this.data.allowGiveUp || 0,
          giveUpDeadline: this.data.giveUpDeadline || '',
          allowMultipleEnroll: this.data.allowMultipleEnroll || 0,
          maxEnrollCount: this.data.maxEnrollCount || 0,
          multipleEnrollType: this.data.multipleEnrollType || [],
          requireCount: this.data.requireCount === 0 ? 0 : 1,
          grpMode: this.enableGroupCorp ? 1 : 0, // 是否集团版 0 否 1是
          rules
        };
        this.loadingSave = true;
        const res = await SDK.editProjects(this.data.id, data);
        this.loadingSave = false;
        if (res.error) {
          if (this.enableMsg) {
            this.$message.error(res.error.message);
          } else {
            this.$emit('save', res);
          }
        } else {
          if (this.enableMsg) {
            this.$message.success(this.language().msg_save_success);
          }
          this.dataCache = JSON.stringify(this.data);
          data.id = this.data.id;
          this.$emit('save', data);
        }
      },
      async createSignup(callback) {
        const SDK = this.$parent.SDK;
        let params = {
          'appCode': this.createParams.appCode,
          'projectName': this.createParams.projectName,
          'coverUrl': this.createParams.coverUrl,
          'shortUrl': this.createParams.shortUrl,
          'intro': this.createParams.intro,
          'clientInfo': this.createParams.clientInfo,
          'chargeUsers': this.createParams.chargeUsers,
          'appProjectId': this.createParams.appProjectId,
          'appProjectUrl': this.createParams.appProjectUrl,
          'remarkUrl': this.createParams.remarkUrl,
          grpMode: this.enableGroupCorp ? 1 : 0,
          userId: this.createParams.userId,
          orgId: this.createParams.orgId,
          'projectId': this.createParams.projectId
        };
        const res = await SDK.createSignup(params);
        clearInterval(this.numTimer);
        this.isCreateSuccess(callback, res);
      },
      isCreateSuccess(callback, res) {
        const SDK = this.$parent.SDK;
        clearTimeout(this.numTimer);
        this.numTimer = setTimeout(async()=>{
          if (this.num > 5) {
            clearTimeout(this.numTimer);
            this.$fmessage({ message: res.error.message, type: 'warning' });
          } else {
            const detail = await SDK.getManageProjectDetail({ projectId: this.createParams.projectId });
            if (detail.error) {
              this.num++;
              this.isCreateSuccess(res, callback);
            } else {
              clearTimeout(this.numTimer);
              callback(res);
            }
          }
        }, 200);
      },
      save() {
        if (!this.auditTemplateCode && this.data.needAudit) {
          return this.$message.error(
            this.language().msg_auditMsg || '请先设置审核模版'
          );
        }
        if (this.data.allowOtherEnroll === 1 && this.data.appointEnrollUserIds.length > 5000) {
          this.$message.error(
            this.language().msg_appointEnroll || '代报名人员不可超过5000人'
          );
          return false;
        }
        this.$refs.form.validate(async value => {
          if (value) {
            if (!this.id) {
              this.createSignup((res)=>{
                this.id = this.createParams.projectId;
                this.data.id = this.createParams.projectId;
                this.editSignup();
              });
            } else {
              this.editSignup();
            }
          }
        });
      },
      async getConfig(appCode) {
        const SDK = this.$parent.SDK;
        // 获取表单配置
        // await SDK.putConfigData('te', { configData: JSON.stringify(this.cfgs) });
        this.$parent.fmessage(await SDK.getConfigData(appCode), cfgs => {
          this.loadingValue = false;
          this.$set(this, 'cfgs', JSON.parse(cfgs.data || JSON.stringify({})));
          this.$nextTick(() => {
            this.$refs.form.clearValidate();
          });
        });
      },
      setDetailData(res) {
        const allows = [];
        res.allowSelfEnroll && allows.push('allowSelfEnroll');
        res.allowOtherEnroll && allows.push('allowOtherEnroll');
        // oss
        let enrollRange = [];
        let excludeRange = [];
        if (res.projectEnrollRange) {
          if (res.projectEnrollRange.rangeList) {
            enrollRange = res.projectEnrollRange.rangeList.map(r => {
              return {
                id: r.objId,
                name: r.objName,
                fullname: r.objName,
                _type: r.objType,
                includeAll: r.objLevel
              };
            });
          }
          if (res.projectEnrollRange.rangeExcludeList) {
            excludeRange = res.projectEnrollRange.rangeExcludeList.map(e => {
              return {
                id: e.objId,
                name: e.objName,
                fullname: e.objName,
                _type: e.objType
              };
            });
          }
        }
        this.data = {
          id: res.id || this.createParams.appProjectId || '',
          formalQuota: res.formalQuota || 0,
          maxQuota: res.maxQuota || 0,
          pointPrice: res.pointPrice || 0,
          enrollTime:
          res.startTime && res.endTime ? [res.startTime, res.endTime] : [],
          enrollRange,
          needExcludeRange: res.needExcludeRange || 0,
          excludeRange,
          allows,
          allowSelfEnroll: res.allowSelfEnroll || 0,
          allowOtherEnroll: res.allowOtherEnroll || 0,
          otherEnrollType: res.otherEnrollType || 3,
          appointEnrollUserIds: (res.appointEnrollUserIds || []).map(_ => ({
            ..._,
            fullname: _.name,
            _type: _.type,
            includeAll: _.level
          })),
          needAudit: res.needAudit || 0,
          auditTemplateCode: res.auditTemplateCode || 'enroll_center',
          positions: [],
          grades: [],
          cers: [],
          exams: [],
          wheres: [],
          score: 0,
          scoreType: 2,
          entryDate: '',
          entryDateType: 4,
          teacherLevel: [],
          needSurvey: res.needSurvey || 0,
          surveies: res.surveyTemplateId
            ? [
              {
                id: res.surveyTemplateId,
                name: res.surveyTemplateName
              }
            ]
            : [],
          needAttach: res.needAttach || 0,
          attachTypeOption: res.attachTypeOption || [],
          allowGiveUp: res.allowGiveUp || 0,
          giveUpDeadline: res.giveUpDeadline || '',
          allowMultipleEnroll: res.allowMultipleEnroll || 0,
          maxEnrollCount: res.maxEnrollCount || 0,
          multipleEnrollType: res.multipleEnrollType || [],
          projectEnrollRangeCache: res.projectEnrollRange || {
            rangeList: [],
            rangeExcludeList: []
          },
          requireCount: res.requireCount === 0 ? 0 : 1,
          concer: 1,
          conexams: 1
        };
        const rules = res.rules || [];
        for (let i = 0; i < rules.length; i++) {
          if (rules[i].selected) {
            this.data.wheres.push(rules[i].ruleCode);
            this.data[rules[i].ruleCode] = rules[i].inputValue
              ? rules[i].inputValue.value || this.data[rules[i].ruleCode]
              : this.data[rules[i].ruleCode];
            this.data[rules[i].ruleCode + 'Type'] = rules[i].compareType
              ? rules[i].compareType
              : this.data[rules[i].ruleCode + 'Type'];
            if (rules[i].ruleCode === 'teacherLevel') {
              this.data[rules[i].ruleCode] = this.data[rules[i].ruleCode].map(
                _ => ({
                  label: _.name,
                  value: _.id
                })
              );
            }
            if (rules[i].ruleCode === 'exams') {
              this.data['conexams'] = rules[i].inputValue.requireCount === 0 ? 0 : 1;
            }
            if (rules[i].ruleCode === 'cers') {
              this.data['concer'] = rules[i].inputValue.requireCount === 0 ? 0 : 1 ;
            }
          }
        }
        this.dataCache = JSON.stringify(this.data);
        this.auditTemplateCode = this.data.needAudit;
      }
    }
  },
  async created() {
    const SDK = this.$parent.SDK;
    if (!this.id) {
      this.$parent.fmessage(
        await SDK.getAuditCodeData(this.createParams.appCode),
        async(res) => {
          this.data.auditTemplateCode = res.data;
        }
      );
      this.data.id = this.createParams.projectId;
      this.getConfig(this.createParams.appCode);
    } else {
      this.loadingValue = true;
      this.$parent.fmessage(
        await SDK.getManageProjectDetail({ projectId: this.id }),
        async(res) => {
          this.setDetailData(res);
          this.getConfig(res.appCode);
        }
      );
    }
  }
};
</script>

<style scoped lang="scss">
.yxtbiz-signup{
  .condition{
    ::v-deep .yxt-form-item__content {
      line-height:22px!important;
    }
  }
}

</style>
